import { memo } from "react";
import { Handle, Position } from "reactflow";
import { Direction } from "containers/Resources/screens/ResourcesSingle/components/Visualization/visualization.service";
import { ObjectTemplateReadOnlyCard } from "./ObjectTemplateReadOnlyCard";
import { CanvasNodeProps } from "./ObjectTemplateNode";
import { NodeDataProps } from "./utils";

export const ObjectTemplateReadOnlyNode = memo(
    ({ data, isConnectable }: CanvasNodeProps<NodeDataProps>) => {
        const isHorizontalDirection = data.layoutDirection === Direction.Horizontal;

        const onExpand =
            data.onExpandTemplate && data.value?.id
                ? () => {
                      const id = data.value?.id;
                      if (id) {
                          data.onExpandTemplate?.(id);
                      }
                  }
                : undefined;

        return (
            <div className="nowheel">
                <ObjectTemplateReadOnlyCard
                    data={data.value}
                    onExpand={onExpand}
                    referenceTargetNames={data.referenceTargetNames}
                />
                <Handle
                    type="source"
                    id="source"
                    position={isHorizontalDirection ? Position.Right : Position.Bottom}
                    isConnectable={isConnectable}
                />
                <Handle
                    type="target"
                    id="target"
                    position={isHorizontalDirection ? Position.Left : Position.Top}
                    isConnectable={isConnectable}
                />
            </div>
        );
    }
);
